export default __webpack_public_path__ + "static/media/mail-icon.7a8f4a80.svg";